/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import navbarSearchAndPinList from '@/layouts/components/navbar/navbarSearchAndPinList'
import themeConfig, { colors }  from '@/../themeConfig.js'
import store from './store.js'
// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

// *From Auth - Data will be received from auth provider
const userDefaults = {
  email       : 'info@arftower.com',
  username    : 'Arf', // From Auth require('@/assets/images/logo/arf_logo.jpeg')
  role        : 'admin'
}


// Check if device is touch device
// This is used to remove perfect scrollbar from touch devices
// Using Dynamic components
const is_touch_device = () => {
  const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ')
  const mq = function (query) {
    return window.matchMedia(query).matches
  }

  if (('ontouchstart' in window) || window.DocumentTouch) {
    return true
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('')
  return mq(query)
}


// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
  AppActiveUser           : userDefaults,
  bodyOverlay             : false,
  eventImage              : '',
  eventImagePreview              : '',
  showPopup               : false,
  showImagePopup          : false,
  isVerticalNavMenuActive : true,
  is_touch_device         : is_touch_device(),
  mainLayoutType          : themeConfig.mainLayoutType || 'vertical',
  navbarSearchAndPinList,
  reduceButton            : themeConfig.sidebarCollapsed,
  verticalNavMenuWidth    : 'default',
  verticalNavMenuItemsMin : false,
  scrollY                 : 0,
  alarm_mode              : true,
  starredPages            : navbarSearchAndPinList['pages'].data.filter((page) => page.is_bookmarked),
  theme                   : themeConfig.theme || 'light',
  themePrimaryColor       : colors.primary,

  // Can be used to get current window with
  // Note: Above breakpoint state is for internal use of sidebar & navbar component
  windowWidth: null,

  isUserLoggedIn: async () => {
    let isAuthenticated = false

    await store.dispatch('checkTokenValid').then((response) => {
      console.log(response)
      if (response.status === 200) {
        isAuthenticated = true
      } else {
        isAuthenticated = false
      }
    }).catch(error => {
      console.log(error)
      isAuthenticated = false
    })
    console.log('is logged in')
    console.log(isAuthenticated)
    return isAuthenticated
  },
  token_valid: false,
  audio: new Audio(require('../assets/sounds/alarm.wav')),
  event_data: [],
  event_detail: [],
  cam_images: [],
  ptz: null,
  camera: null,
  bolge_data: [],
  user_list: [],
  isletme_list: [],
  seflik_list: [],
  kule_list: [],
  kamera_list: [],
  pass: false
}

export default state
